/* global axios */
import ApiClient from '../ApiClient';

// Tình trạng nhận thông báo trên điện thoại của người đang đăng nhập.
// Trả `{ status, last_received_at, has_phone_subscription }`.
class PushHealthAPI extends ApiClient {
  constructor() {
    super('profile/push_health');
  }

  show() {
    return axios.get(this.url);
  }
}

export default new PushHealthAPI();
